import {
  DropdownMenuSubContent,
  DropdownMenuItem,
} from "@/components/ui/library/dropdown-menu";

interface ChatOptionsProps {
  children: any[];
  selectedChildId: number | null;
  onSelectChild: (childId: number) => void;
}

export function ChatOptions({
  children,
  selectedChildId,
  onSelectChild,
}: ChatOptionsProps) {
  return (
    <DropdownMenuSubContent className="w-[220px] bg-white border border-[#e6e8e7] rounded-[16px] shadow-[0px_0px_20px_0px_rgba(0,0,0,0.05)] p-1 gap-1">
      {children.length === 0 ? (
        <div className="px-2.5 py-3 text-[12px] text-[#9ba3a0] text-center">
          No applications yet
        </div>
      ) : (
        children.map((child: any) => (
          <DropdownMenuItem
            key={child.id}
            className={`h-9 px-2.5 py-2 rounded-[12px] cursor-pointer gap-2 ${
              selectedChildId === child.id ? "bg-[#eaf5f1]" : ""
            }`}
            onSelect={(e) => {
              e.preventDefault();
              onSelectChild(child.id);
            }}
          >
            <p className="text-[14px] font-normal text-[#374741] tracking-[-0.56px] leading-[1.35] flex-1 truncate">
              {child.name}
            </p>
          </DropdownMenuItem>
        ))
      )}
    </DropdownMenuSubContent>
  );
}
